<template>
  <div>
    <unavailability-modal ref="makeUnavailableModal" :item="selectedItem" @onUnavailability="onUnavailability" />
    <div v-if="fetching" class="bg-grey-light text-center py-6">
      <h3>
        <i class="fa fa-refresh fa-spin" />
        Fetching Menu...
      </h3>
    </div>
    <div v-if="!fetching && filterdMenuItems.length === 0" class="bg-grey-light text-center py-6">
      <h3>
        No items found
      </h3>
    </div>
    <accordion v-for="(menu, index) in filterdMenuItems" :title="menu.item_type" :key="index" class="bg-grey-light">
      <div
        v-for="item in menu.items"
        :key="item.id"
        class="px-4 md:px-10 py-4 border-b border-solid flex flex-col md:flex-row"
      >
        <div class="w-full md:w-3/4 flex flex-col justify-center">
          <div class="flex">
            <div class="sm:w-1/3 md:w-auto mr-2">
              <div class="item-img-container mr-4">
                <img :src="item.image || itemImage()" alt="Item Image" />
              </div>
            </div>
            <div class="sm:w-2/3 md:w-auto flex flex-col">
              <p class="leading-normal text-black font-bold text-lg pb-4">{{ item.name }}</p>
              <p v-if="item.has_addon && item.is_available" class="text-primary text-md pb-4">
                <span class="font-bold mr-2 underline cursor-pointer" @click="loadAddons(item.name, item.id)">
                  Add-Ons available
                </span>
              </p>
              <p v-if="item.description" class="pb-4 pr-2" style="color:#7d7d7d">{{ item.description }}</p>
              <p>
                <i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" />
                <span v-else>रू</span>
                {{ item.price }}
              </p>
            </div>
          </div>
        </div>
        <div class="w-full md:w-1/4 flex flex-col justify-between items-end">
          <div class="flex items-center mb-4">
            <p class="mt-4 mr-2">Available</p>
            <pt-form-group class="flex">
              <pt-form-switch
                ref="'acceptSwitch'+item.id"
                :disabled="processing"
                v-model="item.is_available"
                on-label="Yes"
                off-label="No"
                @input="changeAvailability(item)"
              />
            </pt-form-group>
            <p v-if="!item.is_visible" class="text-red">
              <i class="fa fa-info-circle text-red mt-2" />
              Made invisible inside app by Pathao Admin
            </p>
          </div>
          <div class="flex justify-end">
            <pt-button variant="secondary-outline" size="md" class="mr-2" @action="showAddEditItemModal(item)">
              <i class="fa fa-pencil mr-2" />
              Edit
            </pt-button>
            <pt-button variant="danger-outline" size="md" @action="showDeleteItemModal(item)">
              <i class="fa fa-trash mr-2" />
              Delete
            </pt-button>
          </div>
        </div>
      </div>
    </accordion>

    <add-edit-item-modal
      ref="addEditItemModal"
      :item-id="selectedItem && selectedItem.id"
      :categories="categories"
      :menu-hours="menuHours"
      :is-edit="selectedItem !== null"
    />
    <delete-item-modal
      ref="deleteItemModal"
      :disabled="processing"
      body-text="Are you sure you want to delete this item?"
      @onConfirm="deleteItem"
    />

    <pt-modal ref="addonModal" size="medium">
      <div slot="modal-header" class="text-lg">Add-Ons of {{ addonName }}</div>
      <div slot="modal-body">
        <div style="max-height: 400px" class="overflow-y-scroll"><Addons :id="addonId" :show="true" /></div>
      </div>
    </pt-modal>
  </div>
</template>

<script>
import apiRequest from '@src/utils/apiRequest';
import Accordion from '@components/custom/Accordion';
import { PtFormInput, PtFormGroup, PtFormSwitch } from '@pathao/ui-components/esm/FormComponents';
import { PtButton } from '@pathao/ui-components';
import { PtModal } from '@pathao/ui-components/esm/Modal';
import Addons from './Addons';
import { RESTO_MENUS, RESTO_DELETE_ITEM, RESTO_MENUS_UPDATE } from '@src/config/apiEndpoints';
import unavailabilityModal from '@components/modals/makeUnavailable.vue';
import addEditItemModal from '@components/modals/addEditItem.vue';
import DeleteItemModal from '@components/modals/deleteModal.vue';
import isBDPhoneNumber from '@src/utils/isBdNumber';

export default {
  components: {
    Accordion,
    PtFormInput,
    PtFormGroup,
    PtFormSwitch,
    PtModal,
    PtButton,
    Addons,
    unavailabilityModal,
    addEditItemModal,
    DeleteItemModal,
  },
  props: {
    search: {
      type: String,
      default: '',
    },
    categories: {
      type: Array,
      default: () => [],
    },
    menuHours: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      menus: [],
      fetching: false,
      processing: false,
      activeBtn: 'items',
      addonName: '',
      addonId: '',
      selectedItem: null,
    };
  },
  computed: {
    filterdMenuItems() {
      const searchRegex = new RegExp(this.search, 'i');
      return this.menus
        .map(menu => {
          const filteredItems = menu.items.filter(item => item.name.match(searchRegex));

          if (filteredItems.length > 0) {
            return {
              ...menu,
              items: filteredItems,
            };
          }

          return null;
        })
        .filter(menu => menu !== null);
    },
  },
  created() {
    this.getMenus();
    this.$sendEvent('RS_FoodItems');
  },
  methods: {
    isBDPhoneNumber,
    itemImage() {
      return require('@assets/images/item.png');
    },
    changeAvailability(item) {
      this.selectedItem = item;
      if (!item.is_available) this.showMakeUnavailabilityModal();
      else this.changeStatus(item);
    },
    showMakeUnavailabilityModal() {
      this.$refs.makeUnavailableModal.show();
    },
    onUnavailability(duration) {
      duration === false
        ? (this.selectedItem.is_available = !this.selectedItem.is_available)
        : this.changeStatus(this.selectedItem, duration);
    },
    showAddEditItemModal(item = null) {
      this.selectedItem = item;
      this.$refs.addEditItemModal.show();
    },
    showDeleteItemModal(item = null) {
      this.selectedItem = item;
      this.$refs.deleteItemModal.showModal();
    },
    closeDeleteItemModal() {
      this.selectedItem = null;
      this.$refs.deleteItemModal.closeModal();
    },
    deleteItem() {
      this.processing = true;
      let payload = {
        url: RESTO_DELETE_ITEM.replace(':itemId', this.selectedItem.id),
        method: 'DELETE',
      };
      apiRequest(payload)
        .then(response => {
          this.processing = false;
          this.$notification.success(response.data.message);
          this.closeDeleteItemModal();
        })
        .catch(() => {
          this.processing = false;
          this.$notification.error('failed to delete item');
        });
    },
    changeStatus(item, duration = 0) {
      let payload = {
        url: RESTO_MENUS_UPDATE,
        method: 'POST',
        data: {
          is_available: item.is_available,
          item_id: item.id,
          auto_available_after: duration,
        },
      };

      let push = {
        category: item.category.name,
        name: item.name,
        price: item.price,
        current_status: item.is_available,
        auto_available_after: duration,
      };
      this.processing = true;
      const eventName = item.is_available ? 'RS_ItemAvailableYes' : 'RS_ItemAvailableNo';
      this.$sendEvent(eventName, push);

      apiRequest(payload)
        .then(response => {
          this.processing = false;
          this.$notification.success(response.data.message);
        })
        .catch(() => {
          this.processing = false;
          this.$notification.error('failed to update status');
        });
    },
    loadAddons(name, id) {
      this.addonName = name;
      this.addonId = id;
      this.$refs.addonModal.showModal();
    },
    getMenus() {
      let payload = {
        url: RESTO_MENUS,
        method: 'GET',
      };
      this.fetching = true;
      apiRequest(payload)
        .then(response => {
          this.menus = response.data.data;
          this.fetching = false;
        })
        .catch(() => {
          this.fetching = false;
        });
    },
  },
};
</script>
